// extracted by mini-css-extract-plugin
module.exports = {"areaChart":"areaChart__areaChart___jOZ88"};